import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  RocketOutlined,
  PictureOutlined,
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
  BellOutlined,
  SafetyOutlined,
  BarChartOutlined,
  ShopOutlined,
  CodeOutlined,
  FileTextOutlined,
  SnippetsOutlined,
  BookOutlined,
  HomeOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Layout as AntLayout, Menu, Button, theme, Dropdown, Badge, Avatar } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const { Header, Sider, Content } = AntLayout;

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, hasPermission } = useAuth();
  
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    },
    {
      key: '/business-managers',
      icon: <ShopOutlined />,
      label: 'BM 管理',
    },
    {
      key: '/public-pages',
      icon: <HomeOutlined />,
      label: '公共主页',
    },
    {
      key: '/developer-accounts',
      icon: <CodeOutlined />,
      label: '开发者账号',
    },
    {
      key: '/fb-users',
      icon: <UserOutlined />,
      label: 'FB 用户管理',
    },
    {
      key: '/campaigns',
      icon: <RocketOutlined />,
      label: '广告系列',
    },
    {
      key: '/campaign-lookup',
      icon: <SearchOutlined />,
      label: '系列查询',
      disabled: true,
    },
    {
      key: '/campaign-templates',
      icon: <FileTextOutlined />,
      label: '系列模板(旧)',
    },
    {
      key: '/ad-series-templates',
      icon: <FileTextOutlined />,
      label: '广告系列模板',
    },
    {
      key: '/ad-creation',
      icon: <RocketOutlined />,
      label: '创建广告',
    },
    {
      key: '/ad-creation/drafts',
      icon: <SnippetsOutlined />,
      label: '草稿箱',
    },
    {
      key: '/creative-copy',
      icon: <BookOutlined />,
      label: '文案库',
    },
    {
      key: '/materials',
      icon: <PictureOutlined />,
      label: '素材管理',
    },
    {
      key: '/material-collections',
      icon: <FileTextOutlined />,
      label: '素材集管理',
    },
    {
      key: '/tasks',
      icon: <RocketOutlined />,
      label: '任务管理',
    },
    {
      key: '/auto-rules',
      icon: <SafetyOutlined />,
      label: '自动规则',
    },
    {
      key: '/reports',
      icon: <BarChartOutlined />,
      label: '数据报表',
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    },
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      danger: true,
    },
  ];

  const disabledMenuKeys = new Set(['/campaign-lookup']);

  const handleMenuClick = ({ key }) => {
    if (disabledMenuKeys.has(key)) return;
    navigate(key);
  };

  const handleUserMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
      navigate('/login');
    }
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} theme="light">
        <div style={{ 
          height: 64, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          borderBottom: '1px solid #f0f0f0'
        }}>
          <h3 style={{ margin: 0, color: '#1890ff' }}>
            {collapsed ? 'FB' : 'FB Ads Pro'}
          </h3>
        </div>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <AntLayout>
        <Header style={{ 
          padding: '0 24px', 
          background: colorBgContainer,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #f0f0f0'
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: '16px', width: 64, height: 64 }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Badge count={5} size="small">
              <BellOutlined style={{ fontSize: 18, cursor: 'pointer' }} />
            </Badge>
            <Dropdown
              menu={{ items: userMenuItems, onClick: handleUserMenuClick }}
              placement="bottomRight"
            >
              <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                <Avatar icon={<UserOutlined />} />
                <span>{user?.username || '用户'}</span>
              </div>
            </Dropdown>
          </div>
        </Header>
        <Content style={{ 
          margin: '24px 16px', 
          padding: 24, 
          minHeight: 280,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
          overflow: 'auto'
        }}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
